const InfoIcon = props => {
    return (
        <img {...props} alt="info_icon.png" src={require('./info_icon.png')} />
    );
};

export default InfoIcon;
